export default __webpack_public_path__ + "static/media/extra2.35287fa1.png";